<template>
  <div class="flex flex-col justify-between h-[100dvh] p-16 desk:p-32">
    <div>
      <img
        :src="`/logos/${useGlobalContentStore().domainMap?.logoUrl}.svg`"
        class="w-70"
        alt="Session.map logo"
      >
    </div>
    <div class="desk:max-w-440">
      <div class="type-headline-lg mb-4">{{ $t('error500.headline') }}</div>
      <div class="mb-16 type-base">{{ $t('error500.subheadline') }}</div>
      <div class="mb-40">
        <button
          class="btn inline-block"
          type="button"
          @click="handleError"
        >{{ $t('error500.button') }}</button>
      </div>
      <div class="type-sm mb-16 withUnderline">
        <img src="/icons/refresh.svg" class="w-20 inline-block mr-8">
        <span v-html="$t('error500.try1')" />
      </div>
      <div class="type-sm mb-16 withUnderline">
        <img src="/icons/505.svg" class="w-20 inline-block mr-8">
        <span v-html="$t('error500.try2')" />
      </div>
      <div class="type-sm mb-48 withUnderline">
        <img src="/icons/mail.svg" class="w-20 inline-block mr-8">
        <span v-html="$t('error500.try3')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';

defineProps({
  error: Object,
});
const handleError = () => clearError({ redirect: '/' });

</script>

<style scoped lang="postcss">
.withUnderline:deep(a) {
    @apply underline;
}
</style>
